import React, { useEffect, useState, useRef } from 'react';
import EcomCard from '../EcomCard';
import styled from 'styled-components';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';
import EcomCartItem from '../EcomCartItem';
import MessageFeedback from '../../../../FeatureComponents/MessageFeedback';
import ProductCard from '../ProductCard';
import useScreenType from '../../../../Hooks/DeviceType';
import useScreenSize from '../../../../Hooks/DeviceScreenSize';
import Hangers from '../../../../../../assets/imgs/hangers.png';
import { getImg } from '../../../../../Utils/getImg';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import AutoComplete from '../../../../FlyfishComponents/AutoComplete';
import ProductDetails from '../ProductDetails';

type Props = {
	message: string;
	metaData: any;
	token: string;
	tenantId: string;
	botId: string | number;
	time: string;
	showBack: Function;
	showCartData: Function;
	showCart: boolean;
	reasonAPIPayload;
	secondAPI;
	responseId;
	colorMode: string;
	setSelectedProductData;
	handleStyleAdvisor: Function;
	styleAdvisor;
	styleAdvisorCache;
	getTitleMessage;
	handleSubmit;
	conversationId: number;
	queryText: string;
	categoriesProductsArray: any;
	setTopProductsRowsCounter: any;
	openThumbsPopup;
	thumbFilledUp;
	popUpSnackBar;
	messageId;
	storeStyle;
	enableStyleAdvisor;
	advisorTitle;
	staticDetailsURL;
	onClose;
	topProductID;
	nextPage;
	enablePagination;
	handleSort;
	enablePDP;
	product_count;
	totalProductCount;
	ecomSearchVertical;
	//topProductIds
};

const EcomChatDiv = styled.div`
	font-family: var(--fontFamily);
	width: 100%;
	height: calc(100vh - 65px);
	overflow-y: hidden;
	overflow-x: hidden;
	&.ff-ecom-pdp {
		overflow-y: auto;
		height: calc(-125px + 100vh);
	}
	&.ff-ecom-cart-chat {
		& > .ecom-product-list {
			overflow: hidden !important;
			height: unset;
		}
	}
	.ff-sort-by {
		display: flex;
		justify-content: end;
		align-items: center;
		margin-right: 54px;
		&.mobile,
		&.cartVisible {
			display: none;
		}
	}
	@media screen and (max-width: 800px) {
		& > .filter-message-time-holder {
			& > .message-time {
				width: 86vw !important;
				display: block !important;
				margin-left: 35px !important;
				margin-right: 0 !important;
				& > .time {
					text-align: right;
					margin-top: 16px;
				}
				& > .ff-ecom-feedback {
					& > .sf-message-feedback {
						margin-right: 12px;
					}
				}
			}
		}
	}

	& > .filter-message-time-holder {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: #f7f7f7;
		border-bottom: 1px solid #c6c4c4;
		padding: 6px 0;
		position: relative;
		& > .back-button {
			display: flex;
			align-items: center;
			position: absolute;
			left: 15px;
			cursor: pointer;
			& > svg {
				margin-right: 9px;
			}
			& > div {
				color: #111111;
			}
		}

		& > .message-time {
			width: 70vw;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-right: 35px;
			font-family: var(--fontFamily);
			& > .ff-ecom-feedback {
				& > .sf-message-feedback {
					margin-right: 20px;
					& .sf-time-wrapper {
						padding: unset !important;
						padding-left: 2px !important;
						&.server {
							margin-left: unset !important;
							margin-top: unset !important;
						}
					}
				}
			}
			& > .message {
				width: fit-content;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				margin-right: 24px;
				font-size: 16px;
				font-weight: 500;
			}
			& > .time {
				color: #363636;
				opacity: 0.5;
				font-size: 12px;
				white-space: nowrap;
				margin-right: 10px;
			}
		}
	}

	& > .ecom-product-list {
		overflow: auto;
		height: calc(
			100vh - 82px
		); /* 126px - reason - removal of sort and placed it to header*/
		width: 100%;
		/* padding-top: 12px; */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		// margin-top: 13px;

		&.no-products {
			align-items: center;
		}
		// @media (max-width: 820px) {
		// 	height: calc(100vh - 144px);
		// }
		& > .list-of-products {
			width: 100%;
			padding-bottom: 20px;
			& > .category {
				margin: 20px 0;
				& > p {
					font-size: 20px;
					color: ${(props) =>
						props.colorMode === 'dark' ? '#171615' : 'var(--colorScale-0)'};
					text-transform: uppercase;
					letter-spacing: 0.8px;
					font-family: var(--fontFamily);
					border-bottom: 2px solid
						${(props) =>
							props.colorMode === 'dark' ? '#171615' : 'var(--colorScale-0)'};
					padding-bottom: 6px;
					font-weight: bold;
				}
			}
			& > .product-row {
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(200px, max-content));
				justify-content: flex-start;
				padding: 10px 20px 10px 24px;
				gap: 24px;
				&.tablet {
					justify-content: center;
					display: flex;
					flex-wrap: wrap;
				}
				& > .product {
					display: flex;
					max-width: 240px;

					@media (max-width: 430px) {
						min-width: 49.5%;
					}
				}
				&.mobile {
					display: grid;
					grid-template-columns: auto auto;
					& > .product {
						min-width: auto;
					}
				}
				&.tablet {
					& > .product {
						width: 240px;
					}
				}
			}
			& > .view-products {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 16px;
				& > .show-more,
				& > .show-less {
					display: flex;
					align-items: center;
					font-size: 12px;
					gap: 10px;
					font-family: var(--fontFamily);
					cursor: pointer;
					& > p {
						width: fit-content;
					}
				}
				& > .show-more {
					color: ${(props) =>
						props.colorMode === 'dark'
							? 'var(--colorScale-3)'
							: 'var(--colorScale-0)'};
					& > svg {
						stroke: ${(props) =>
							props.colorMode === 'dark'
								? 'var(--colorScale-3)'
								: 'var(--colorScale-0)'};
					}
				}
				& > .show-less {
					& > svg {
						stroke: ${(props) =>
							props.colorMode === 'dark'
								? 'var(--colorScale-3)'
								: 'var(--colorScale-0)'};
					}
					color: ${(props) =>
						props.colorMode === 'dark'
							? 'var(--colorScale-3)'
							: 'var(--colorScale-0)'};
				}
			}
		}
		&.mobile {
			padding-top: 12px;
			margin-top: 0;

			height: calc(100vh - 110px);
			& > .list-of-products {
				padding: 0px;
				& > .product-row {
					gap: 12px;
					padding: 10px 12px 10px 12px;
				}
			}
		}
	}
`;
const EcomChats = ({
	message,
	metaData,
	token,
	tenantId,
	botId,
	time,
	showBack,
	showCartData,
	showCart,
	reasonAPIPayload,
	responseId,
	secondAPI,
	colorMode,
	setSelectedProductData,
	handleStyleAdvisor,
	styleAdvisor,
	styleAdvisorCache,
	getTitleMessage,
	queryText,
	handleSubmit,
	conversationId,
	categoriesProductsArray,
	setTopProductsRowsCounter,
	openThumbsPopup,
	thumbFilledUp,
	popUpSnackBar,
	messageId,
	storeStyle,
	enableStyleAdvisor,
	advisorTitle,
	staticDetailsURL,
	onClose,
	topProductID,
	nextPage,
	enablePagination,
	handleSort,
	enablePDP,
	product_count,
	totalProductCount,
	ecomSearchVertical,
}: Props) => {
	const [ecomCategories, setEcomCategories] = useState(
		metaData && metaData.categories
	);
	const [reasonData, setReasonData] = useState<any>();
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [productsPerRow, setProductsPerRow] = useState(4);
	const [selectedProductID, setSelectedProductID] = useState(4);
	const [selectedMainProduct, setSelectedMainProduct] = useState(null);
	const screenSize = useScreenSize();
	const [categoriesArray, setCategoriesArray] = useState<any>([
		{
			category: metaData && metaData.categories && metaData.categories[0],
			products: metaData && metaData.products,
			rows: 2,
		},
	]);
	const [categoriesLLMArray, setCategoriesLLMArray] = useState<any>([]);
	const [category, setCategory] = useState('');
	const [quantityUpdated, setQuantityUpdated] = useState(false);
	const deviceType = useScreenType();
	const listRef = useRef(null);

	// useEffect(() => {

	// 	let width = window.innerWidth;
	// 	if (width > 600 && width < 800) {
	// 		setProductsPerRow(3);
	// 	} else if (width <= 800) {
	// 		setProductsPerRow(2);
	// 	} else if (width > 800 && width < 1366) {
	// 		setProductsPerRow(3);
	// 	} else {
	// 		setProductsPerRow(4);
	// 	}
	// }, [window.innerWidth]);
	useEffect(() => {
		setCategoriesArray([
			{
				category: metaData && metaData.categories && metaData.categories[0],
				products: metaData && metaData.products,
				rows: 2,
			},
		]);
		// setTimeout(() => {
		// 	showMore(metaData && metaData.categories && metaData.categories[0])
		// }, 2000);
	}, [metaData]);

	useEffect(() => {
		metaData && metaData.products.length && nextPage();
	}, []);
	useEffect(() => {
		if (
			categoriesProductsArray &&
			categoriesProductsArray.length &&
			categoriesProductsArray[0] !== undefined
		) {
			setCategoriesArray(categoriesProductsArray);
		}

		const hasScrollbar =
			listRef.current !== null &&
			listRef.current.scrollHeight > listRef.current.clientHeight;
		if (
			!hasScrollbar &&
			categoriesProductsArray &&
			parseInt(product_count) < totalProductCount &&
			!showCart
		) {
			nextPage();
		}
	}, [categoriesProductsArray]);
	useEffect(() => {
		const hasScrollbar =
			listRef.current.scrollHeight > listRef.current.clientHeight;
		if (
			!hasScrollbar &&
			categoriesProductsArray &&
			parseInt(product_count) < totalProductCount &&
			!showCart
		) {
			nextPage();
		}
	}, [window.innerWidth]);

	const showLess = (category) => {
		setQuantityUpdated(true);
		saveStateSession(
			'FF-topProducts-counter',
			Number(loadStateSession('FF-topProducts-counter')) - 1
		);
		setCategoriesArray((prevCategoriesArray) => {
			return prevCategoriesArray.map((item) => {
				if (item.category === category) {
					return { ...item, rows: item.rows - 1 }; // Update rows for the matching category
				}
				return item;
			});
		});
	};
	const displaySymbol = (currencyCode) => {
		return getCurrencySymbol(currencyCode);
	};

	// useEffect(() => {
	// 	if (categoriesArray.length && !quantityUpdated) {
	// 		let array = [];
	// 		categoriesArray.map((category, categoryIndex) => {
	// 			let productIdsArray =
	// 				category &&
	// 				category.products &&
	// 				category.products.map((eachItem) => {
	// 					return eachItem.product_id;
	// 				});
	// 			let stringifyProductIDs = String(productIdsArray);

	// 			stringifyProductIDs &&
	// 				stringifyProductIDs !== 'undefined' &&
	// 				stringifyProductIDs !== 'false' &&
	// 				Axios.get(
	// 					`${window['BASE_URL']
	// 					}/shop/${tenantId}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
	// 						'FS-countryCode'
	// 					)}`,
	// 					{
	// 						headers: {
	// 							'x-tenant-id': tenantId,
	// 							Authorization: `Bearer ${token}`,
	// 						},
	// 					}
	// 				).then((resp: any) => {
	// 					let response = resp.data.response;
	// 					let products = response.data.products;
	// 					let categoryWithResp = {
	// 						category: category.category,
	// 						products: products,
	// 					};

	// 					array.push(categoryWithResp);
	// 					if (categoryIndex === categoriesArray.length - 1) {
	// 						let finalArray = [...array];
	// 						setCategoriesLLMArray(finalArray);
	// 					}
	// 				});
	// 		});
	// 	}
	// }, [categoriesArray]);
	let isNextPageCalled = false;
	const handleScroll = () => {
		const list = listRef.current;

		if (list) {
			// Check if the user scrolled to the bottom
			const isAtBottom =
				list.scrollTop + list.clientHeight + 100 >= list.scrollHeight - 100;

			if (isAtBottom && !isNextPageCalled) {
				if (enablePagination && !showCart) {
					nextPage();
				}

				isNextPageCalled = true;
			} else {
				isNextPageCalled = false;
			}
		}
	};

	useEffect(() => {
		const list = listRef.current;

		if (list) {
			list.addEventListener('scroll', handleScroll);

			// Cleanup
			return () => list.removeEventListener('scroll', handleScroll);
		}
	}, []);
	// useEffect(() => {
	// 	if (!enablePDP) {
	// 		const list = listRef.current;

	// 		if (list) {
	// 			list.addEventListener('scroll', handleScroll);

	// 			// Cleanup

	// 		}
	// 	}
	// }, [enablePDP]);

	// const handleProductDetails = (productId) => {
	// 	setReasonData('');

	// 	Axios.get(
	// 		window['BASE_URL'] +
	// 			`/conversation/tenant/${tenantId}/bot/${botId}/recommendation_rational?text=${queryText}&conversation_id=${conversationId}&message_id=${messageId}&productId=${productId}`
	// 	).then((response) => {
	// 		setReasonData(response.data.products[0].reason);
	// 		// setReasonQuery('')
	// 	});
	// };
	useEffect(() => {
		setEcomCategories(metaData && metaData.categories);
		//	handleProductDetails();
		// setReasonData('');
	}, [metaData]);
	// const productSelection = (product) => {
	// 	setSelectedProduct(
	// 		product.product_id === selectedProduct ? null : product.product_id
	// 	);
	// 	saveStateSession('FF-productID', product.product_id);
	// 	saveStateSession('FF-productName', product.title);
	// 	showBack();
	// 	showCartData();
	// 	setSelectedProductID(product.product_id);
	// };
	// const styleSelection = (product) => {
	// 	setSelectedProduct(
	// 		product.productId === selectedProduct ? null : product.productId
	// 	);
	// 	saveStateSession('FF-productID', product.productId);
	// 	saveStateSession('FF-productName', product.title);
	// 	showBack();
	// 	showCartData();
	// 	setSelectedProductID(product.productId);
	// };
	const EcomProductList = (page: string = '') => {
		return (
			<div
				className={`ecom-product-list ${deviceType} ${
					metaData && metaData.products && metaData.products.length
						? ''
						: 'no-products'
				}`}
				ref={listRef}
				style={{ display: showCart ? 'none' : 'flex' }}>
				{metaData && metaData.products && metaData.products.length ? (
					<>
						<div className='list-of-products'>
							{ecomCategories &&
								ecomCategories.map((category, categoryIndex) => {
									let indexOfProduct = categoriesArray.findIndex((item) => {
										return item.category === category;
									});

									if (categoriesArray[indexOfProduct]) {
										return (
											<>
												{categoryIndex !== 0 && (
													<div className='category'>
														{categoriesArray[indexOfProduct] &&
														categoriesArray[indexOfProduct].products.length >=
															1 ? (
															<p>{category}</p>
														) : null}
													</div>
												)}

												<div className={`product-row ${deviceType}`}>
													{categoriesArray[indexOfProduct] &&
														categoriesArray[indexOfProduct].products
															.filter((product) =>
																page === 'ecom cart'
																	? categoryIndex !== 0 &&
																	  product.category === category
																	: product.category === category
															)
															.map((product, index) => {
																let llmMatchedProduct: any = [];
																let price = product.price;
																let currency = product.currency;
																let imageOnHover = product.media_link;
																let sale_price = product.sale_price;

																let showDiscount =
																	product.category.toLowerCase() ===
																	'best deals'
																		? true
																		: false;
																return (
																	<div
																		className={`product ${
																			product.product_id === selectedProduct
																				? 'selected'
																				: ''
																		}`}
																		key={index}
																		onClick={() => {
																			if (enablePDP) {
																				setSelectedMainProduct(product);
																				// productSelection(product);
																				showCartData();
																			} else {
																				window.open(
																					product.product_url,
																					'_blank'
																				);
																			}
																			// setCategory(product.category);
																			// handleProductDetails(product.product_id);
																		}}>
																		<ProductCard
																			key={product.product_id + index}
																			currency={product.currency}
																			media_link={product.media_link}
																			title={product.title}
																			price={product.price}
																			sale_price={product.sale_price}
																			details={product}
																			// noHover
																		/>
																		{/* <EcomCard
																			selectedProduct={
																				product.product_id === selectedProduct
																			}
																			key={index}
																			title={product.title}
																			price={price}
																			currency={displaySymbol(currency)}
																			header={product.header}
																			mediaType={product.media_type}
																			mediaLink={product.media_link}
																			imageOnHover={imageOnHover}
																			showDiscount={showDiscount}
																			colorMode={colorMode}
																			sale_price={sale_price}
																		/> */}
																	</div>
																);
															})}
												</div>
											</>
										);
									} else {
										null;
									}
								})}
						</div>
					</>
				) : (
					<div className='ff-no-products'>
						<div>
							{ecomSearchVertical === 'footwear' ? (
								<img height={120} src={getImg('no-shoes-found.webp')} alt='' />
							) : (
								<img src={Hangers} alt='' />
							)}

							<div className='ff-chatbot-body1 sorry'>
								Sorry, no results found
							</div>
							<div className='ff-chatbot-body1 search-term'>
								Please try a different search term or change the filters
							</div>
						</div>
					</div>
				)}
			</div>
		);
	};

	return (
		<EcomChatDiv
			colorMode={colorMode}
			className={`ff-ecom-chats ${showCart ? 'ff-ecom-pdp' : ''}`}>
			{/* <div className='filter-message-time-holder'>
				<div className='message-time'>
					<div
						className='message'
						dangerouslySetInnerHTML={{ __html: message }}
					></div>

					{message !=
						"Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later." ? (
						<div className='ff-ecom-feedback'>
							<MessageFeedback
								messageType={'server'}
								timeStamp={time}
								popUpSnackBar={popUpSnackBar}
								openThumbsPopup={openThumbsPopup}
								thumbFilledUp={thumbFilledUp}
								handleSubmit={handleSubmit}
								showFeedbackIcons={true}
								messageId={messageId}
								data={''}
							/>
						</div>
					) : null}
				</div>
			</div> */}
			<>{EcomProductList()}</>
			{showCart && enablePDP ? (
				<ProductDetails
					userInput={queryText}
					conversationId={responseId}
					messageId={messageId}
					hideProductDetailsPage={() => {
						onClose();
					}}
					mainProduct={selectedMainProduct}
					chatMessageIndex={0}
					advisoryProductId={''}
					updateChatscreen={''}
					productIndex={0}
					intent={'direct'}
					allProducts={[]}
					userUploadedImage={''}
					enableCart={() => {
						// setShowCart(true);
						// setfavList(false);
					}}
					deviceType={deviceType}
					colorMode={colorMode}
					botId={botId}
					tenantId={tenantId}
					responseId={responseId}
					msgId={messageId}
					queryText={queryText}
					enableStyleAdvisor={enableStyleAdvisor}
				/>
			) : null}
		</EcomChatDiv>
	);
};

export default EcomChats;
